import script from "./OcOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./OcOverview.vue?vue&type=script&setup=true&lang=js"

import "./OcOverview.vue?vue&type=style&index=0&id=2769d426&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2769d426"]])

export default __exports__